// Minimal GA4 event helper. No-ops if gtag is not present.
// Usage: trackEvent('book_appointment_click', { location: 'nav' })

declare global {
  interface Window {
    gtag?: (...args: any[]) => void
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params || {})
  }
}


